<template>
  <div style="font-size:16px;height:100%;width:100%;background:#eff1f5"
       class="indexPage">
    <div class="top">
      <div class="title"><span>永嘉县</span>水旱灾害防御平台</div>
      <div class="lable"
           v-for="(item,index) in topnavs"
           :key="index"
           @mouseover="mouseOver(index,item)"
           @click="navcheck(item,index,item.type)">
        <span :class="{'navon': pathNow() === item.type}">{{item.name}}</span>
        <span :class="{'checkon': pathNow() === item.type}"></span>
      </div>
      <div class="logout" @click="logOut">
        <span class="out"></span>
        <span>退出</span>
      </div>
      <div class="logout" @click="changepwd">
        <span class="yaoshi"></span>
        <span>修改密码</span>
      </div>
      <div class="user">
        <span class="gly"></span>
        <span>{{displayName}}</span>
      </div>
      <div class="warn" @click="warnShow = !warnShow, show = false">
        <span class="yjxx"></span>
        <span>预警信息</span>
        <div class="yjxxCount" v-show="warnCountShow">{{warnCount}}</div>
        <audio controls="controls" loop="loop" hidden src="@/assets/alarm.wav" ref="audio"></audio>
      </div>
      <transition name="el-zoom-in-top">
        <div class="warnContent" v-show="warnShow" :class="{'showWarnContent':showWarnContent}">
          <span class="triangle"></span>
          <span class="closeBtn" @click="warnShow = !warnShow">×</span>
          <el-aside width="100%">
            <el-menu :default-openeds="['1', '2', '3']">
              <el-submenu index="1">
                <template class="aside_title" slot="title">雨情信息</template>
                <el-menu-item-group>
                  <template class="aside_child_title" slot="title">
                    <span class="item item_name">1小时超过30mm</span>
                    <span class="item item_num" v-if="this.total1 === 0">0个</span>
                    <span class="item item_num" v-else>
                      <a
                        style="color:red;margin-right:5px;font-size:16px;"
                        @click="openWaterOrRain('rain')"
                      >{{this.total1}}</a>个
                    </span>
                  </template>
                  <el-menu-item v-for="(item, index) in rainfall.rowsOf1h" :key="index">
                    <span class="item item_name">
                      <span class="circular_title">{{index + 1}}</span>
                      {{item.stnm}}
                    </span>
                    <span class="item item_num">{{item.rain1}}</span>
                  </el-menu-item>
                </el-menu-item-group>
                <el-menu-item-group>
                  <template class="aside_child_title" slot="title">
                    <span class="item item_name">3小时超过50mm</span>
                    <span class="item item_num" v-if="this.total3 === 0">0个</span>
                    <span class="item item_num" v-else>
                      <a
                        style="color:red;margin-right:5px;font-size:16px;"
                        @click="openWaterOrRain('rain')"
                      >{{this.total3}}</a>个
                    </span>
                  </template>
                  <el-menu-item v-for="(item, index) in rainfall.rowsOf3h" :key="index">
                    <span class="item item_name">
                      <span class="circular_title">{{index + 1}}</span>
                      {{item.stnm}}
                    </span>
                    <span class="item item_num">{{item.rain3}}</span>
                  </el-menu-item>
                </el-menu-item-group>
                <el-menu-item-group>
                  <template class="aside_child_title" slot="title">
                    <span class="item item_name">24小时超过100mm</span>
                    <span class="item item_num" v-if="this.total24 === 0">0个</span>
                    <span class="item item_num" v-else>
                      <a
                        style="color:red;margin-right:5px;font-size:16px;"
                        @click="openWaterOrRain('rain')"
                      >{{this.total24}}</a>个
                    </span>
                  </template>
                  <el-menu-item v-for="(item, index) in rainfall.rowsOf24h" :key="index">
                    <span class="item item_name">
                      <span class="circular_title">{{index + 1}}</span>
                      {{item.stnm}}
                    </span>
                    <span class="item item_num">{{item.rain24}}</span>
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
              <el-submenu index="2">
                <template class="aside_title" slot="title">水库信息</template>
                <el-menu-item-group>
                  <template slot="title">
                    <span class="item item_name">超汛限</span>
                    <span class="item item_num" v-if="this.reservoirTotal === 0">0个</span>
                    <span class="item item_num" v-else>
                      <a
                        style="color:red;margin-right:5px;font-size:16px;"
                        @click="openWaterOrRain('reservoir')"
                      >{{this.reservoirTotal}}</a>个
                    </span>
                  </template>
                  <el-menu-item
                    v-for="(item, index) in riverAndReservoirInfo.rowsOfReservoir"
                    :key="index"
                  >
                    <span class="item item_name">
                      <span class="circular_title">{{index + 1}}</span>
                      {{item.stnm}}
                    </span>
                    <span class="item item_num">{{item.water| rounding}}</span>
                    <span class="item item_limited">(汛限：{{item.wrz}})</span>
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
              <el-submenu index="3">
                <template class="aside_title" slot="title">河道信息</template>
                <el-menu-item-group>
                  <template slot="title">
                    <span class="item item_name">超警戒</span>
                    <span class="item item_num" v-if="this.riverWarningTotal === 0">0个</span>
                    <span class="item item_num" v-else>
                      <a
                        style="color:red;margin-right:5px;font-size:16px;"
                        @click="openWaterOrRain('river')"
                      >{{this.riverWarningTotal}}</a>个
                    </span>
                  </template>
                  <el-menu-item
                    v-for="(item, index) in riverAndReservoirInfo.rowsOfOverflowWarn"
                    :key="index"
                  >
                    <span class="item item_name">
                      <span class="circular_title">{{index + 1}}</span>
                      {{item.stnm}}
                    </span>
                    <span class="item item_num">{{item.water}}</span>
                    <span class="item item_limited">(警戒：{{item.wrz}})</span>
                  </el-menu-item>
                </el-menu-item-group>
                <el-menu-item-group>
                  <template slot="title">
                    <span class="item item_name">超保证</span>
                    <span class="item item_num" v-if="this.riverGuaTotal === 0">0个</span>
                    <span class="item item_num" v-else>
                      <a
                        style="color:red;margin-right:5px;font-size:16px;"
                        @click="openWaterOrRain('river')"
                      >{{this.riverGuaTotal}}</a>个
                    </span>
                  </template>
                  <el-menu-item
                    v-for="(item, index) in riverAndReservoirInfo.rowsOfOverflowGru"
                    :key="index"
                  >
                    <span class="item item_name">
                      <span class="circular_title">{{index + 1}}</span>
                      {{item.stnm}}
                    </span>
                    <span class="item item_num">{{item.water}}</span>
                    <span class="item item_limited">(保证：{{item.grz}})</span>
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
              <!-- <el-submenu index="4">
                <template class="aside_title" slot="title">
                  通告单
                  <span class="tgdSpan" @click="searchNotice()">{{theNoticeCount}}</span> 份
                </template>
              </el-submenu> -->
            </el-menu>
          </el-aside>
        </div>
      </transition>
      <div
        class="shortCutBtn"
        v-show="btnShow"
        @click="show = !show, warnShow = false"
        title="快捷方式"
      >
        <span class="el-icon-s-operation"></span>
      </div>
      <transition name="el-zoom-in-bottom">
        <div class="out_content">
          <transition name="el-zoom-in-top">
            <div v-show="show" class="shortCutContent">
              <span class="closeBtn" @click="show = !show">×</span>
              <ul class="shortCut_list">
                <li
                  class="shortCut_item"
                  v-for="(item, index) in shortCutData"
                  :class="{'sel_active':item.routerUrl==$route.name}"
                  :key="index"
                  @click="shortCutCheck(item,index)"
                >{{item.name}}</li>
              </ul>
            </div>
          </transition>
        </div>
      </transition>
    </div>
    <div class="iconTable" id="navtable" :class="{'hiddenIconTable':iconTableStatus}" @mouseleave="iconTableStatus=true">
      <div class="list"
          :class="{'list2': item.imgid==='lssh' || item.imgid==='lssh1'}"
          v-for="(item,index) in getAllIconTables"
          :key="index"
          @click="iconcheck(index,item.type,item.state,item.meta,item)">
        <svg class="icon" aria-hidden="true" style="color:#75819a">
          <use ref="iconitem" :href="'#'+item.imgid" v-bind:class="{'active':$route.name === item.type}"></use>
        </svg>
        <div class="listname" :class="{'listname_on':$route.name === item.type}">
          <span>{{item.name}}</span>
        </div>
      </div>
    </div>
    <router-view class="main"></router-view>
     <!-- 异常测站 -->
    <div class="error-tip" :class="[tipShow ? 'slow-show' : 'slow-hidden']" v-if="isShowErrorTip">
        <div class="tip-content" ref="basedContent">
          <div class="close-btn">
            <span
              v-if="tipShow"
              id="close-btn-content"
              class="el-icon-s-unfold"
              title="隐藏异常测站提醒"
              @click="tipShow = false"
            ></span>
            <span
              v-else
              id="close-btn-content"
              class="el-icon-s-fold"
              title="显示异常测站提醒"
              @click="tipShow = true"
            ></span>
            <el-image
              :src="require('@/assets/homepage_img/error_ling.gif')"
            ></el-image>
            <span>异常测站提醒</span>
          </div>
          <div class="tip-content-content">
            <div
              class="error-list-item"
              title="点击查看异常水位站"
              @click="errorHandle()"
            >
              <span>异常水位站点:</span>
              <span>{{ ppNum }}</span>
              <span>个</span>
            </div>
            <div
              class="error-list-item"
              title="点击查看异常雨量站"
              @click="errorHandle()"
            >
              <span>异常雨量站点:</span>
              <span>{{ mmNum }}</span>
              <span>个</span>
            </div>
          </div>
        </div>
    </div>
      <!-- 异常测站列表详情 -->
      <el-dialog
        :title="'异常站点列表'"
        class="pop-barechart-container"
        :visible.sync="dialogShow"
        :close-on-click-modal="false"
        width="50%"
      >
        <div class="pop-content-body" v-loading="loading">
          <div class="table-list">
            <div class="main" ref="stationList">
              <el-table
                :data="errorTableData"
                border
                stripe
                :header-cell-style="{ background: '#F5F7FA' }"
                :max-height="errorTableHeight"
                style="width: 100%"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  label="序号"
                  type="index"
                  width="80"
                >
                </el-table-column>
                 <el-table-column
                  align="center"
                  prop="stcd"
                  :show-overflow-tooltip="true"
                  label="测站编码"
                  min-width="80"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="addvnm"
                  :show-overflow-tooltip="true"
                  label="乡镇名称"
                  min-width="80"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="stnm"
                  :show-overflow-tooltip="true"
                  label="站名"
                  min-width="80"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="ynRelation"
                  :show-overflow-tooltip="true"
                  label="是否关联预警村落"
                  min-width="80"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="sttp"
                  :show-overflow-tooltip="true"
                  label="测站类型"
                  min-width="80"
                >
                  <template slot-scope="scope">
                    <span>
                      {{
                        scope.row.sttp === "PP"
                          ? "雨量站"
                          : scope.row.sttp === "ZZ"
                          ? "河道站"
                          : scope.row.sttp === "RR"
                          ? "水库站"
                          : scope.row.sttp === "MM"
                          ? "气象站"
                          : "-"
                      }}
                    </span>
                  </template>
                </el-table-column>
                 <el-table-column
                  align="center"
                  prop="water"
                  :show-overflow-tooltip="true"
                  label="水位"
                  min-width="70"
                >
                  <template slot-scope="scope">
                    {{scope.row.water?scope.row.water:'-'}}
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="rain"
                  :show-overflow-tooltip="true"
                  label="雨量"
                  min-width="70"
                >
                 <template slot-scope="scope">
                    {{scope.row.rain?scope.row.rain:'-'}}
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="time"
                  :show-overflow-tooltip="true"
                  label="发生异常时间"
                  min-width="120"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-dialog>
    <el-dialog width="450px" :title="title" :visible.sync="diagShow" :close-on-click-modal='false' class="abow_dialog">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="旧密码" prop="oldPassWord">
          <el-input type="password" v-model="ruleForm.oldPassWord" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="newPassWord">
          <el-input type="password" v-model="ruleForm.newPassWord" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">重置</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import userTypes from '@/store/types/user'
import homepageTypes from '@/store/types/homepage'
import { getUserId } from '@/utils/auth'
import errorApi from '@/api/homepage'
export default {
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.newPassWord) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      choosed: 0,
      activeComponent: 'Homepage',
      topnavs: [],
      displayName: '',
      title: '修改密码',
      diagShow: false,
      ruleForm: {
        newPassWord: '',
        checkPass: '',
        oldPassWord: ''
      },
      rules: {
        newPassWord: [
          { validator: this.Global.checkPassword },
          { min: 8, message: '长度不能小于8位' },
          { max: 18, message: '长度不大于18位' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        oldPassWord: [
          { required: true, message: '原密码不能为空' }
        ]
      },
      iconTableStatus: true,
      warnShow: false,
      showWarnContent: false,
      warnCountShow: false,
      shortCutData: [
        {
          name: '实时雨情',
          routerUrl: 'Monitor/RealTimeRain'
        },
        {
          name: '水库水情',
          routerUrl: 'Monitor/ReservoirWater'
        },
        {
          name: '河道水情',
          routerUrl: 'Monitor/RiverWater'
        },
        {
          name: '预警信息查看',
          routerUrl: 'WarningCenter/warnInformationView'
        },
        {
          name: '台风路径',
          routerUrl: 'Monitor/Typhoon'
        }
      ],
      sID: '22',
      btnShow: true,
      show: false,
      rainfall: {},
      reservoirInfo: [],
      riverInfor: {},
      riverAndReservoirInfo: [],
      stationType: '1,2',
      hours: '1',
      total30m: 0,
      total1: 0,
      total3: 0,
      total24: 0,
      riverTotal: 0,
      reservoirTotal: 0,
      riverWarningTotal: 0,
      riverGuaTotal: 0,
      warnCount: 0,
      theNoticeData: '',
      theNoticeTownData: [],
      theNoticeCount: 0,
      isShowErrorTip: true,
      tipShow: false,
      loading: false,
      dialogShow: false,
      dialogTitle: '水文站',
      errorTableHeight: 100,
      allErrorTableData: [],
      errorTableData: [],
      ppNum: 0,
      mmNum: 0,
      beforeStidArr: [],
      errType: '0',
      timer: null,
      timer1: null
    }
  },
  computed: {
    getAllIconTables: {
      get () {
        return this.$store.state.allIconTables
      },
      set () {
        this.$store.dispatch('setSubMenu', '')
      }
    }
  },
  methods: {
    iconcheck: function (index, type, theid, name, item) {
      if (!item.isLink) {
        this.$store.dispatch('setAllowPerm', { name: name, type: type })
        this.$router.push({ name: type })
        this.warnShow = false
      } else {
        window.open(type)
      }
    },
    navcheck: function (item, index, type) {
      if (!item.isLink) {
        if (index - 1 < 0) {
          this.Global.allIconTables = this.Global.allIconTables
        }
        this.$router.push({ name: type, query: { id: item.name } })
        this.choosed = index
        this.activeComponent = type
        this.warnShow = false
      } else {
        window.open(type)
      }
    },
    pathNow () {
      return this.$route.name.split('/')[0]
    },
    changepwd () {
      this.ruleForm = {}
      this.title = '修改密码'
      this.diagShow = true
      this.$refs['ruleForm'].resetFields()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.Id = getUserId()
          this.$store.dispatch(userTypes.CHANGE_PWD, this.ruleForm).then(() => {
            this.$notify.success({ title: '成功', message: '保存成功。' })
            this.loading = false
            this.diagShow = false
            this.ruleForm = {}
            localStorage.clear()
            this.$router.push({ path: '/login' })
          }).catch(() => { this.loading = false })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    logOut: function () {
      this.$confirm('您确定退出吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store
          .dispatch(userTypes.LOGOUT)
          .then(() => {
            localStorage.clear()
            this.$router.push({ path: '/login' })
          })
          .catch(() => {
            localStorage.clear()
            this.$router.push({ path: '/login' })
          })
      }).catch(() => {
      })
    },
    mouseOver (index, item) {
      if (index - 1 < 0) {
        this.Global.allIconTables = this.Global.allIconTables
        this.iconTableStatus = true
      } else {
        this.$store.dispatch('setSubMenu', item.name)
        if (this.getAllIconTables.length > 0) {
          this.iconTableStatus = false
        } else {
          this.iconTableStatus = true
        }
      }
    },
    // 快捷菜单
    shortCutCheck (item, index) {
      this.$router.push({ name: item.routerUrl })
    },
    // 获取预警信息中的雨情信息
    getRainFallData () {
      this.$store
        .dispatch(homepageTypes.GET_OVERFLOW_WARNING_RAIN, {
          sID: this.sID,
          mainStation: true
        })
        .then(data => {
          this.rainfall = data
          this.total30m = data.total30m
          this.total1 = data.total1
          this.total3 = data.total3
          this.total24 = data.total24 === undefined ? 0 : data.total24
          this.warnCount += this.total1 + this.total3 + this.total24
        })
    },
    // 获取水库、河道信息
    getRiverAndReservoirData () {
      this.$store.dispatch(homepageTypes.GET_OVERFLOW_WARNING_WATER, {
        stationType: this.stationType,
        sID: this.sID,
        mainStation: true
      }).then(data => {
        this.riverAndReservoirInfo = data
        this.reservoirTotal = data.reservoirTotal
        this.riverTotal = data.riverTotal
        this.riverGuaTotal = data.riverGuaTotal
        this.riverWarningTotal = data.riverWarningTotal
        this.warnCount += this.riverTotal + this.reservoirTotal
        if (this.warnCount > 0) {
          this.warnCountShow = true
        }
      })
    },
    // 新汛情通告单
    getNoticeData () {
      // this.$store
      //   .dispatch(intelligentTypes.GET_GET_FLOOD_NOTICE, {
      //     IsNew: 1,
      //     pageIndex: 1,
      //     pageSize: 100
      //   })
      //   .then(data => {
      //     if (data.total > 0) {
      //       this.$refs.audio.currentTime = 0
      //       this.$refs.audio.play()
      //       data.results.forEach(element => {
      //         this.theNoticeTownData.push(
      //           element.adnm.replace('镇', '').replace('街道', '')
      //         )
      //       })
      //       this.theNoticeData = data.results
      //       this.activeTab = this.theNoticeTownData[0]
      //       this.theNoticeCount = data.total
      //       this.warnCount += this.theNoticeCount
      //       this.setValue(data.results[0])
      //     } else {
      //       this.$refs.audio.pause()
      //       this.theNoticeCount = 0
      //     }
      //   })
    },
    openWaterOrRain (type) {
      var url = ''
      switch (type) {
        case 'reservoir':
          url = 'Monitor/ReservoirWater'
          break
        case 'river':
          url = 'Monitor/RiverWater'
          break
        case 'rain':
          url = 'Monitor/RealTimeRain'
          break
      }
      this.warnShow = false
      this.$router.push({ name: url })
    },
    // 获取所有数据，定时刷新用
    getAllData () {
      this.warnCount = 0
      // this.getNoticeData()
      this.getRainFallData()
      this.getRiverAndReservoirData()
    },
    // 请求异常水文站/气象站统计数据，控制是否显示右下角异常水文/气象站提示框
    getErrorStationNum () {
      let _this = this
      errorApi.getProblematicStation().then(res => {
        let tempList = Object.assign([], res.data.rows ? res.data.rows : [])
        _this.allErrorTableData = Object.assign([], tempList)
        _this.computedErrorTableData(_this.allErrorTableData)
      })
    },
    // 处理获取到的异常水文气象站，判断是否出现新的异常数据，如果有，则显示提示框否则不显示
    computedErrorTableData (arr) {
      let _this = this
      let stidArr = []
      let tempList = []
      let tempPPList = []
      let tempMMList = []
      tempPPList = arr.filter(e => e.sttp !== 'PP')
      tempMMList = arr.filter(e => e.sttp === 'PP')
      _this.$set(_this, 'ppNum', tempPPList.length)
      _this.$set(_this, 'mmNum', tempMMList.length)
      if (arr && arr.length > 0) {
        arr.forEach(el => {
          stidArr.push(el.stid)
        })
        if (_this.beforeStidArr.length === 0) {
          _this.tipShow = true
          _this.beforeStidArr = Object.assign([], stidArr)
        } else {
          for (let item in stidArr) {
            if (!(_this.beforeStidArr.includes(stidArr[Number(item)]))) {
              tempList.push(stidArr[Number(item)])
            }
          }
          if (!_this.tipShow) { // 只有本来弹框就未开启状态下，才重新打开提示弹框，否则值更新数值
            if (tempList.length > 0) { // 存在新的异常测站数据，显示提示框
              _this.tipShow = true
            }
          }
          _this.beforeStidArr = Object.assign([], stidArr)
        }
      }
    },
    // 点击异常水文/其项测站提示信息
    errorHandle (type, name) {
      let _this = this
      _this.dialogTitle = name
      _this.dialogShow = true
      _this.loading = true
      _this.$nextTick(() => {
        let errorTableElement = _this.$refs.stationList
        _this.errorTableHeight = errorTableElement.offsetHeight
        _this.errorTableData = Object.assign([], _this.allErrorTableData)
        _this.loading = false
      })
    },
    // 获取用户信息，获取不到则退出到登陆页面(并根据角色判断是否拥有显示异常水文站/气象站提示框的权限)
    getUserInfo () {
      let _this = this
      _this.$store.dispatch(userTypes.GET_USER_INFO).then(res => {
        let tempObj = Object.assign({}, res || {})
        if (tempObj && tempObj.roles) {
          if ((tempObj.roles.indexOf(14) >= 0) || (tempObj.roles.indexOf(15) >= 0)) { // 暂时写死，14、15代表超管和管理员
            _this.getErrorStationNum()
          }
        } else {
          _this.$router.replace({ path: '/login' })
        }
      }).catch(() => {
        _this.$router.replace({ path: '/login' })
      })
    }
  },
  created () {
    this.getUserInfo()
    this.ListMainMenu().then(res => {
      this.topnavs = res
    })
    this.$store.dispatch(userTypes.GET_USER_INFO).then(res => {
      this.displayName = res.displayName
      // 当用户为超管或管理员时，异常水文站/气象站提示框可见
      if (res.userRoles[0].roleName === '管理员' || res.userRoles[0].roleName === '超级管理员') {
        this.isShowErrorTip = true
      } else {
        this.isShowErrorTip = false
      }
    }).catch(() => {
    })
  },
  mounted () {
    this.getAllData()
    // 五分钟刷新一次
    // this.timer = setInterval(() => {
    //   this.getAllData()
    // }, 1000 * 60 * 5)
    this.timer1 = setInterval(() => {
      this.getUserInfo()
    }, 1000 * 60 * 5)

    this.$nextTick(() => {
      document.body.onmousemove = e => {
        var div = document.getElementById('navtable')
        if (div) {
          var divy = div.offsetTop + div.offsetHeight
          if (e.clientY > divy) {
            this.iconTableStatus = true
          }
        }
      }
    })
  },
  filters: {
    rounding (num) {
      var result = parseFloat(num)
      if (isNaN(result)) {
        return '-'
      } else if (result === 0) {
        return num
      }
      result = Math.round(num * 100) / 100
      var value = result.toString() // 将数字转换为字符串

      let posdecimal = value.indexOf('.') // 小数点的索引值

      // 当整数时，posdecimal=-1 自动补0
      if (posdecimal < 0) {
        posdecimal = value.length
        value += '.'
      }

      // 当数字的长度< 小数点索引+2时，补0
      while (value.length <= posdecimal + 1) {
        value += '0'
      }
      // console.log(typeof value)
      // let val = parseFloat(value)
      return value
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
    }
    if (this.timer1) {
      clearInterval(this.timer1)
    }
  }
}
</script>
<style>
*::-webkit-scrollbar {
  width: 0.35rem;
  height: 0.35rem;
  background-color: #ffffff;
  cursor: pointer;
}
*::-webkit-scrollbar-track {
  border-radius: 0.1rem;
  background-color: #ffffff;
  cursor: pointer;
}
*::-webkit-scrollbar-thumb {
  /*width: 0.1rem;
     */
  cursor: pointer;
  height: 0.2rem;
  border-radius: 0.1rem;
  background-color: rgba(39, 39, 39, 0.3);
}
</style>
<style scoped lang="less">
body {
  background-color: #f0f2f6;
  margin: 0;
  padding: 0 0 10px 0;
}
.top {
  background-color: #3d6ffb;
  width: 100%;
  height: 70px;
  z-index: 1999;
  position: relative;
}
.shortCutBtn {
  width: 35px;
  height: 35px;
  position: fixed;
  top: 140px;
  right: 20px;
  background: #334f72;
  border-radius: 5px;
  padding: 5px;
  cursor: pointer;
  z-index: 9999;
  /deep/ .el-icon-s-operation {
    width: 25px;
    height: 25px;
  }
  /deep/ .el-icon-s-operation:before {
    font-size: 25px;
    color: #ffffff;
  }
}
.warnContent {
  width: 330px;
  height: 460px;
  position: absolute;
  top: 60px;
  right: 180px;
  background: rgb(64, 216, 243);
  color: #ffffff;
  border-radius: 5px;
  z-index: 99999;
  box-shadow: 5px 15px 10px #999;
  .closeBtn {
    width: 25px;
    height: 25px;
    margin: 5px 0;
    font-size: 24px;
    text-align: center;
    line-height: 25px;
    display: block;
    float: right;
    cursor: pointer;
  }
  .el-aside {
    width: 100%;
    height: 95%;
    background-color: #fff;
    padding-bottom: 5px;
    .el-menu[role="menubar"] {
      width: 100%;
      height: 100%;
      padding: 0 15px;
      overflow: auto;
      background: #fff;
      border: none;
      li.el-submenu[role="menuitem"] {
        border-bottom: 1px solid #ccc;
        .el-submenu__title {
          font-size: 16px;
          color: #0890d9;
          background: url("../../assets/homepage_img/yjxxtitle_bg.png");
          background-repeat: no-repeat;
          background-size: 5% 25%;
          background-position: left center;
          .el-submenu__icon-arrow {
            display: none;
          }
        }
        ul.el-menu[role="menu"] {
          background-color: #fff;
          .el-menu-item-group {
            .el-menu-item-group__title {
              padding-left: 10px !important;
              color: #3b3838;
              .item {
                height: 100%;
                font-size: 14px;
                text-align: left;
                display: inline-block;
              }
              .item_name {
                width: 50%;
              }
              .item_num {
                width: 50%;
              }
            }
            .el-menu-item {
              padding-left: 10px !important;
              padding-right: 0;
              height: 25px;
              line-height: 25px;
              font-size: 12px;
              .item {
                margin: 0 2%;
              }
              .item_name {
                width: 35%;
                .circular_title {
                  width: 14px;
                  height: 14px;
                  line-height: 14px;
                  font-size: 14px;
                  margin-right: 5px;
                  text-align: center;
                  display: inline-block;
                  background: #3b4655;
                  color: #ffffff;
                  border-radius: 50%;
                }
              }
              .item_num {
                width: 18%;
              }
              .item_limited {
                width: 28%;
              }
            }
          }
        }
      }
    }
  }
}
.shortCutContent {
  opacity: 1;
  width: 160px;
  /* height: 220px; */
  position: fixed;
  top: 80px;
  right: 20px;
  background: #1266bd;
  color: #ecebcb;
  border-radius: 5px;
  z-index: 99999;
  box-shadow: 5px 5px 10px #6498ce;
  .closeBtn {
    width: 25px;
    height: 25px;
    /* margin-top: 10px; */
    font-size: 24px;
    text-align: center;
    line-height: 25px;
    display: block;
    float: right;
    cursor: pointer;
  }
  .shortCut_list {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-left: 0;
    .shortCut_item {
      width: 100%;
      height: 25px;
      font-size: 14px;
      line-height: 25px;
      list-style: none;
      padding-left: 10px;
      margin: 5px auto;
      cursor: pointer;
      &:hover{
        background: #07aaff;
      }
    }
    .sel_active {
      background: #07aaff;
    }
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.5;
  }
  70% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.5;
  }
  70% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}
.showWarnContent {
  display: block;
}
.triangle {
  width: 20px;
  height: 15px;
  display: block;
  background: url("../../assets/homepage_img/sanjiao.png");
  background-position: center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  margin: 0 auto;
  margin-top: -12px;
}

.warn {
  float: right;
  cursor: pointer;
  color: #ffffff;
  margin-top: 25px;
  margin-right: 20px;
  font-size: 16px;
  .yjxx {
    float: left;
    display: block;
    width: 25px;
    height: 23px;
    background-image: url(../../assets/homepage_img/yjxx.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-right: 5px;
    margin-top: -3px;
  }
  .yjxxCount {
    vertical-align: super;
    border-radius: 12px;
    background: #ff4040;
    text-align: center;
    float: right;
    height: 18px;
    width: 18px;
    line-height: 18px;
    margin-top: -10px;
    font-size: 13px;
  }
}
.checkon {
  display: block;
  width: 15px;
  height: 10px;
  background-image: url(../../assets/monitorimg/checkon.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* bottom: 0; */
  position: relative;
  margin-left: 40px;
  margin-top: 17px;
}
.navon {
  color: #ffff00;
}
.logout {
  /* width: 58px; */
  float: right;
  cursor: pointer;
  color: #ffffff;
  margin-top: 25px;
  margin-right: 20px;
  font-size: 16px;
}
.user {
  /* width: 90px; */
  float: right;
  cursor: pointer;
  color: #ffffff;
  margin-top: 25px;
  margin-right: 20px;
  font-size: 16px;
}

.out {
  float: left;
  display: block;
  width: 20px;
  height: 22px;
  background-image: url(../../assets/monitorimg/tc.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-right: 5px;
}
.yaoshi {
  float: left;
  display: block;
  width: 20px;
  height: 20px;
  background-image: url(../../assets/monitorimg/yaoshi.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-right: 5px;
}
.gly {
  float: left;
  display: block;
  width: 29px;
  height: 29px;
  background-image: url(../../assets/monitorimg/gly.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-right: 5px;
  margin-top: -5px;
}
// .title {
//   float: left;
//   background-image: url(../../assets/monitorimg/title1.png);
//   background-size: 100% 100%;
//   background-repeat: no-repeat;
//   width: 500px;
//   height: 70px;
//   margin-right: 180px;
//   /* margin-top: -13px; */
// }
.title {
  float: left;
  background-image: url(../../assets/monitorimg/title_bt.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 500px;
  height: 40px;
  margin: 20px 50px 0 25px;
  font-size: 24px;
  color: #fff;
  /* margin-top: -13px; */
}
.title>span{
  margin-left:67px;
  color:#ffff00;
  font-size: 25px;
}
.lable {
  font-family: Microsoft YaHei UI;
  font-size: 18px;
  color: #ffffff;
  width: 5.63%;
  height: 100%;
  float: left;
  text-align: center;
  padding-top: 25px;
  cursor: pointer;
  margin-left: 10px;
}
.lable:hover {
  color: #ffff00;
}
</style>
<style lang="less" scoped>
  /deep/ .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }
  /deep/ .el-dialog__title {
    color: #fff;
    margin-left: 85px;
    display: inline-block;
  }
  /deep/ .el-dialog .el-dialog__header {
    background-color: #3e6ffc;
    background-image: url('~@/assets/monitorimg/opentitle.png');
    background-repeat: no-repeat;
    background-position: 18px 28px;
    background-size: 370px 17px;
  }
  /deep/ .el-dialog__body{
    padding-bottom: 0px;
  }
  .iconTable {
    width: 100%;
    height: 80px;
    z-index: 1998;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    position: absolute;
    top: 70px;
    left: 0;
    transition: all 0.5s ease;
    .active{
      color: #3d71fb;
    }
  }
  .hiddenIconTable {
    top: -10px;
  }

.list {
  width: 120px;
  height: 100%;
  float: left;
  text-align: center;
  padding-top: 13px;
  cursor: pointer;
  margin-left: 10px;
}
.list:hover svg use,
.list:hover .listname {
  color: #3d6ffb;
}
.list2 {
  width: 150px;
}
.icon {
  width: 26px;
  height: 26px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* margin-left: 38px; */
}
.listname {
  width: 100%;
  margin-top: 5px;
  color: #666666;
  font-size: 15px;
}
.listname_on {
  color: #3d6ffb !important;
}
.listname span {
  font-size: 16px;
}
.main{
  width: 100%;
  height: calc(100% - 70px);
  overflow: auto;
}
 // 异常测站
  .indexPage {
    position: relative;
    .error-tip {
      width: 200px;
      height: 120px;
      background: #ffffff;
      position: absolute;
      bottom: 20px;
      right: 0;
      z-index: 9999;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
      .tip-content {
        width: 100%;
        height: 100%;
        .close-btn {
          width: 100%;
          height: 30px;
          padding: 0 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #ff4a4a;
          position: relative;
          span {
            min-width: 20px;
            height: 100%;
            display: inline-flex;
            align-items: center;
            font-size: 16px;
            justify-content: center;
            color: #ffffff;
            &::before {
              font-size: 16px;
            }
            &:nth-of-type(2) {
              cursor: pointer;
            }
          }
          #close-btn-content {
            position: absolute;
            left: -20px;
            background: #ff4a4a;
          }
          /deep/ .el-image {
            width: 30px;
            height: 100%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
          }
        }
        .tip-content-content {
          width: 100%;
          height: calc(100% - 30px);
          padding: 10px 0;
          padding-left: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          .error-list-item {
            width: 100%;
            height: 50%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            cursor: pointer;
            span {
              font-family: PingFangSC-Regular;
              font-size: 16px;
              color: #333333;
              letter-spacing: 0;
              &:nth-of-type(2) {
                color: red;
                font-size: 18px;
                padding: 0 5px;
              }
            }
          }
        }
      }
    }
    .slow-show {
      right: 0;
      animation: slowShow 0.5s ease;
    }
    .slow-hidden {
      right: -200px;
      animation: slowHidden 0.5s ease;
    }
    /*定义动画 名称为animate1*/
    @keyframes slowShow {
      /*第一帧样式*/
      from {
        right: -200px;
      }
      /*结束时样式*/
      to {
        right: 0;
      }
    }
    /*定义动画 名称为animate1*/
    @keyframes slowHidden {
      /*第一帧样式*/
      from {
        right: 0;
      }
      /*结束时样式*/
      to {
        right: -200px;
      }
    }
    .pop-barechart-container {
      /deep/ .el-dialog {
        .el-dialog__header {
          background: #217ff4;
          background-image: url("~@/assets/monitorimg/opentitle.png");
          background-repeat: no-repeat;
          background-position: 18px 28px;
          background-size: 370px 17px;
          .el-dialog__title {
            color: #ffffff;
            margin-left: 35px;
          }
          .el-dialog__headerbtn {
            .el-dialog__close {
              color: #ffffff;
            }
          }
        }
        .el-dialog__body {
          width: 100%;
          height: 100%;
          padding: 0 15px;
          padding-top: 15px;
          .pop-content-body {
            width: 100%;
            height: 675px;
            padding-bottom: 20px;
            .table-list {
              width: 100%;
              height: 100%;
              .main {
                width: 100%;
                height: calc(100% - 54px);
              }
            }
          }
        }
      }
    }
  }
</style>
